import learningRouter from "@routers/learningRouter";
import { RouterProvider } from "react-router-dom";

/**
 * AppProvider sets up the router. The EukaBarkProvider (theme) and AppToast
 * are now inside the router's RootLayout so they can access gradeTheme from
 * StudentDataContext.
 */
const AppProvider = () => {
  return <RouterProvider router={learningRouter} />;
};

export default AppProvider;
